import React from 'react';
import { Box } from '../ui';

export const NotFoundTimelineItems = () => {
  return (
    <Box
      position="absolute"
      top="calc(50% + 25px)"
      left="calc(50% - 150px)"
      zIndex="99"
    >
      No values found matching the search criteria
    </Box>
  );
};
